import { render, staticRenderFns } from "./Science-Budgetusage.vue?vue&type=template&id=ca9d5df2&scoped=true&"
import script from "./Science-Budgetusage.vue?vue&type=script&lang=js&"
export * from "./Science-Budgetusage.vue?vue&type=script&lang=js&"
import style0 from "./Science-Budgetusage.vue?vue&type=style&index=0&id=ca9d5df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d5df2",
  null
  
)

export default component.exports